import { render } from "./NewUserComponent.vue?vue&type=template&id=388c963e"
import script from "./NewUserComponent.vue?vue&type=script&lang=js"
export * from "./NewUserComponent.vue?vue&type=script&lang=js"

import "./NewUserComponent.vue?vue&type=style&index=0&id=388c963e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__